import settings from '@/config/settings';

import type {IRole, IRoleCreate, IRoleUpdate} from '@/api/types/role';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

import type {IQueryObject} from '@/assets/core/assets/helpers/serialize';

const url = new URL(settings.SERVICES.BACKEND.URL + '/role');

export const roleAPI = useAPIHook<
  IRole,
  IRole,
  IRoleCreate,
  IRoleUpdate,
  IQueryObject
>(url);
